module.exports = __webpack_public_path__ + "static/sass-icon-8e55a8080322bba99636db4830cc4edb.png";